import axios from 'src/api/Api';
import {
    GET_ALLOCATION_DETAILS_SUCCESS,
    GET_ALLOCATION_DETAILS_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { convertObjectToQueryParams } from 'src/utils/util';

export default function* getAllocationDetailsSaga(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const {
        allocated,
        allocationStatus,
        districtCode,
        setIndex,
        setNo,
        action: allocationAction = 'default',
        batchNo = '',
        currentAccount = '',
        pageLimit = 6,
        pageNum = 0,
        sapOrderNo = '',
    } = action.payload || {};

    const queryParams = convertObjectToQueryParams({
        action: allocationAction,
        allocated,
        allocationStatus,
        batchNo,
        currentAccount,
        districtCode,
        pageLimit,
        pageNum,
        setIndex,
        setNo,
        sapOrderNo,
    });

    const url = `/occ/v2/${baseSiteId}/dashboard/allocationDetails?${queryParams}`;

    try {
        const result = yield axios
            .get(url)
            .then((response) => response.data);

        yield put({
            type: GET_ALLOCATION_DETAILS_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });

        yield put({
            type: GET_ALLOCATION_DETAILS_FAILURE,
            payload: errorHandler(error?.response?.status || '503'),
        });
    }
}
